"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputColor = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _ColorPicker = require("./ColorPicker");

var _style = _interopRequireDefault(require("./style"));

var _style2 = _interopRequireDefault(require("../Input/style"));

var _color = _interopRequireDefault(require("color"));

var defaultColorCode = '#000000';
var getColorPickerClasses = (0, _ThemeProvider.createUseStyles)(_style["default"]);
var getInputClasses = (0, _ThemeProvider.createUseStyles)(_style2["default"]);
/* Checks if the string in the input field is a valid color (in any CSS format),
   then returns the Hex code of the input color or black if it's not a valid CSS color */

var validColorCode = function validColorCode(value) {
  try {
    return (0, _color["default"])(value).hex();
  } catch (error) {// Nothing to do :)
  }

  return defaultColorCode;
};
/* Get the "base color", this is, the color to render in the top-right corner of the gradient box,
   this will be the color with 100% saturation, 50% lightness and the current HUE degrees */


var getBaseColor = function getBaseColor(value) {
  return (0, _color["default"])(validColorCode(value)).lightness(50).saturationl(100);
};

var InputColor = function InputColor(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      onChange = _ref.onChange,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["className", "value", "onChange"]);
  var classes = getColorPickerClasses();
  var inputClass = getInputClasses();

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      lastValue = _useState2[0],
      setLasValue = _useState2[1];

  var _useState3 = (0, _react.useState)(value),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      colorCode = _useState4[0],
      setColorCode = _useState4[1];

  var _useState5 = (0, _react.useState)(getBaseColor(colorCode)),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      baseColor = _useState6[0],
      setBaseColor = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      findPosition = _useState8[0],
      setFindPosition = _useState8[1];

  var inputRef = (0, _react.useRef)(null); //called every time

  var updateColor = function updateColor(colorCode) {
    var _inputRef$current;

    var updateBase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var resetPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    setColorCode(colorCode);
    setFindPosition(resetPosition);
    if (updateBase) setBaseColor(getBaseColor(validColorCode(colorCode)));
    var event = new Event('change', {
      bubbles: true
    });
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.dispatchEvent(event); // @ts-ignore

    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  };

  var handleChange = function handleChange(event) {
    updateColor(event.target.value, true, true);
    event.preventDefault();
    event.stopPropagation();
  }; // update when the value prop has changed


  if (value != lastValue) {
    setLasValue(value);
    setColorCode(value);
    setFindPosition(true);
    setBaseColor(getBaseColor(validColorCode(value)));
  }

  var parsedColorCode = validColorCode(colorCode);
  var invalidCode = parsedColorCode == defaultColorCode && colorCode != defaultColorCode;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.ColorInput, className)
  }, rest), /*#__PURE__*/_react["default"].createElement("input", {
    ref: inputRef,
    value: colorCode,
    onChange: handleChange,
    className: (0, _classnames["default"])(inputClass.Input, classes.ColorCode, (0, _defineProperty2["default"])({}, inputClass.Error, invalidCode)),
    "data-test-id": "color-input"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.ColorPreview,
    style: {
      backgroundColor: parsedColorCode
    },
    tabIndex: 0,
    "data-test-id": "color-input-preview"
  }, /*#__PURE__*/_react["default"].createElement(_ColorPicker.ColorPicker, {
    classes: classes,
    colorCode: parsedColorCode,
    updateColor: updateColor,
    base: baseColor,
    updateBase: setBaseColor,
    findPosition: findPosition,
    setFindPosition: setFindPosition
  })));
};

exports.InputColor = exports["default"] = InputColor;
//# sourceMappingURL=index.js.map